import React from "react";
import { useTheme } from "../../providers/theme-provider";
import useWindowSize from "../../hooks/use-window-size";
import { useTranslation } from "react-i18next";
import spacings from "../../theme/spacings";
import { assetIcons, assetImages } from "../../constants/assets";
import { fontSizes } from "../../theme/font-sizes";

const Steps = () => {
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 1024;

  const isLarge = width >= 768;

  const { t } = useTranslation();

  const paddingLeftRight = isMobile
    ? spacings.leftRightSpacingMobile
    : spacings.leftRightSpacing;

  const paddingTopBottom = isMobile
    ? spacings.topBottomSpacingMobile
    : spacings.topBottomSpacing;

  const steps = [
    {
      icon: assetIcons.rocket,
      title: t("steps.title1"),
      description: t("steps.description1"),
    },
    {
      icon: assetIcons.bulb,
      title: t("steps.title2"),
      description: t("steps.description2"),
    },
    {
      icon: assetIcons.check,
      title: t("steps.title3"),
      description: t("steps.description3"),
    },
  ];

  return (
    <div
      style={{
        backgroundColor: colors.heroBg,
        paddingLeft: paddingLeftRight,
        paddingRight: paddingLeftRight,
        paddingTop: paddingTopBottom,
        paddingBottom: paddingTopBottom,
      }}
      className="max-w-[1400px] mx-auto "
    >
      <div className="md:grid md:grid-cols-2 lg:gap-12 md:gap-6 grid grid-cols-1 gap-6 place-content-between">
        <div className="flex flex-col gap-12 md:order-1 order-2">
          {isLarge && (
            <h3
              className="font-semibold"
              style={{
                fontSize: fontSizes.heading2,
                color: colors.mainHeading,
              }}
            >
              {t("stepsHeading")}
            </h3>
          )}

          <div className={`relative ${isLarge ? "" : "mt-3"}`}>
            {/* Vertical Line */}
            {/* <div
              className="absolute left-5 top-0 h-[75%] w-0.5 "
              style={{
                backgroundColor: colors.line,
              }}
            /> */}

            {/* Steps */}
            <div className="space-y-12">
              {steps.map((step, index) => (
                <div key={index} className="relative flex lg:gap-8 gap-4">
                  {/* Icon Circle */}
                  <div className="relative z-10">
                    <div className="w-10 h-10 rounded-full bg-black flex items-center justify-center">
                      <img src={step.icon} alt="" className="w-5 h-5" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <h3
                      className="font-semibold mb-2"
                      style={{
                        fontSize: fontSizes.heading3,
                        color: colors.mainHeading,
                      }}
                    >
                      {step.title}
                    </h3>
                    <p
                      className="max-w-md"
                      style={{
                        fontSize: fontSizes.body,
                        color: colors.mainText,
                      }}
                    >
                      {step.description}
                    </p>
                  </div>

                  {/* Horizontal Line */}
                  {index < steps.length - 1 && (
                    <div
                      className="absolute left-[19px] md:top-16 min-[390px]:top-[60px] top-[72px] w-0.5 xl:h-24 lg:h-20 min-[540px]:h-16 h-[78px]"
                      style={{
                        marginTop: "-0.25rem",
                        backgroundColor: colors.line,
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex justify-end md:order-2 order-1 relative">
          <img src={assetImages.threeStep} alt="" className="w-[550px]" />

          {!isLarge && (
            <div
              className="p-4 absolute top-[36%]"
              style={{
                backgroundColor: colors.background,
              }}
            >
              <h3
                className="font-semibold"
                style={{
                  fontSize: fontSizes.heading2,
                  color: colors.mainHeading,
                }}
              >
                {t("stepsHeading")}
              </h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Steps;
